'use client';
import { levenstein } from '@s7/fuzzy';
import { caseInsensitiveMatch } from './caseInsensitiveMatch.js';
import { removeNonBreakingSpaces } from './removeNonBreakingSpaces.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var filterSubstringMatch = function(items, value) {
    return items.filter(function(item) {
        if (!item.title) {
            return false;
        }
        return caseInsensitiveMatch(removeNonBreakingSpaces(item.title), value);
    });
};
var sortByLevensteinDistance = function(extra, value) {
    return extra.map(function(item) {
        return _extends({
            distance: (item == null ? void 0 : item.title) ? levenstein(item == null ? void 0 : item.title, value) : Infinity
        }, item);
    }).sort(function(a, b) {
        return a.distance - b.distance;
    });
};
var fractions = function(fraction, n) {
    return [
        Math.ceil((1 - fraction) * n),
        Math.floor(fraction * n)
    ];
};
var filterNavigationItems = function(navigation, value) {
    var _ref = navigation || {}, items = _ref.items, extra = _ref.extra, _ref_maxItems = _ref.maxItems, maxItems = _ref_maxItems === void 0 ? 6 : _ref_maxItems;
    if (!items && !extra) {
        return [];
    }
    var preserveUnfiltered = ((items == null ? void 0 : items.length) || 0) + ((extra == null ? void 0 : extra.length) || 0) <= maxItems;
    if (!value || preserveUnfiltered) {
        return items && extra ? [].concat.apply([], [
            items,
            extra
        ]).slice(0, maxItems) : items ? items.slice(0, maxItems) : extra ? extra.slice(0, maxItems) : [];
    }
    var matchedItems = [];
    var matchedExtra = [];
    if (items) {
        matchedItems = filterSubstringMatch(items, value);
    }
    if (extra) {
        /*
         * https://github.com/ka-weihe/fastest-levenshtein#benchmark
         * */ var satisfiesThreshold = extra.length < 500;
        var withFuzzySearch = value.length >= 3;
        if (withFuzzySearch && satisfiesThreshold) {
            matchedExtra = sortByLevensteinDistance(extra, value);
        } else {
            matchedExtra = filterSubstringMatch(extra, value);
        }
    }
    if (matchedItems.length + matchedExtra.length <= maxItems) {
        return [].concat.apply([], [
            matchedItems,
            matchedExtra
        ]);
    }
    if (matchedItems.length <= maxItems) {
        return [].concat.apply([], [
            matchedItems,
            matchedExtra.slice(0, maxItems - matchedItems.length)
        ]);
    }
    var _fractions = fractions(0.3, maxItems), matchedItemsMaxLength = _fractions[0], matchedExtraMaxLength = _fractions[1];
    return [].concat.apply([], [
        matchedItems.slice(0, matchedItemsMaxLength),
        matchedExtra.slice(0, matchedExtraMaxLength)
    ]);
};

export { filterNavigationItems };
